import { render, staticRenderFns } from "./TheNavbarHorizontal.vue?vue&type=template&id=2033f1b9"
import script from "./TheNavbarHorizontal.vue?vue&type=script&lang=js"
export * from "./TheNavbarHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports